import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const aiPromptApi = createApi({
  reducerPath: "prompt",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["aiPrompt"],
  endpoints: (builder) => ({
    getAllPrompt: builder.query({
      query: () => ({
        url: "/admin/AiPrompt",
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["AllPrompt"],
    }),
    getPromptId: builder.query({
      query: (id) => ({
        url: `/admin/AiPrompt/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["prompt"],
    }),
    createPrompt: builder.mutation({
      query: (prompt) => ({
        url: `/admin/AiPrompt`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: prompt,
      }),
      invalidatesTags: ["AllPrompt", "prompt"],
    }),
    deletePrompt: builder.mutation({
      query: (id) => ({
        url: `/admin/AiPrompt/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: { id },
      }),
      invalidatesTags: ["AllPrompt"],
    }),
    editPrompt: builder.mutation({
      query: (prompt) => ({
        url: `/admin/AiPrompt/${prompt.id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: prompt,
      }),
      invalidatesTags: ["AllPrompt", "prompt"],
    }),
  }),
});

export const {
  useCreatePromptMutation,
  useDeletePromptMutation,
  useEditPromptMutation,
  useGetPromptIdQuery,
  useGetAllPromptQuery,
} = aiPromptApi;
